import React from "react";

import { ResizedImage } from "@hl/shared-features/lib/features/image";

type ImageProps = {
  src: string;
  hasGate: boolean;
};

export const IMAGE_FIT_SIZE = 400;
const MainImage = ({ src, hasGate }: ImageProps) => {
  return (
    <ResizedImage
      src={src}
      fit="contain"
      fitSize={IMAGE_FIT_SIZE}
      styles={(theme) => ({
        image: {
          borderRadius: theme.radius.sm,
          ...(hasGate
            ? {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              }
            : {}),
        },
      })}
    />
  );
};

export default MainImage;
